// Fonction utilitaire pour combiner les news et les blogs et les trier par date
import { getArticles, formatArticles } from "../api/strapi/articlesApi";
import { getNewsDescriptions, formatNewsDescriptions } from "../api/strapi/newsPageApi";

// Fonction pour combiner les news et les blogs
export const combineNewsAndBlogs = async (locale) => {
  try {
    const blogResult = await getArticles(locale);
    if (!blogResult.ok && blogResult.reason !== "NOT_FOUND") {
      console.warn("Blog articles unavailable:", blogResult);
    }
    const formattedBlogs =
      blogResult.ok && Array.isArray(blogResult.data)
        ? formatArticles(blogResult.data)
        : [];

    const newsResult = await getNewsDescriptions(locale);
    if (!newsResult.ok && newsResult.reason !== "NOT_FOUND") {
      console.warn("News descriptions unavailable:", newsResult);
    }
    const formattedNews =
      newsResult.ok && Array.isArray(newsResult.data)
        ? formatNewsDescriptions(newsResult.data)
        : [];

    const blogsWithType = formattedBlogs.map((blog) => ({ ...blog, type: "blog" }));
    const newsWithType = formattedNews.map((news) => ({ ...news, type: "news" }));

    const combined = [...blogsWithType, ...newsWithType];

    combined.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);

      if (isNaN(dateA.getTime())) return 1;
      if (isNaN(dateB.getTime())) return -1;

      return dateB - dateA;
    });

    return combined.slice(0, 5);
  } catch (error) {
    console.error("Erreur lors de la combinaison des news et blogs:", error);
    return [];
  }
};
